import { createContext, useContext, useReducer } from 'react';
import { IrpSearchState, IrpSearchReducer, ACTION_TYPES } from './irp-search-reducer';
import { IIrpPageRequest } from '../../../../model/scp/irp/request/irp-paged-request';
import { IrpSortField } from '../../../../model/scp/irp/irp-sort-field';
import { SortDirection } from '../../../../model/scp/base/sort-direction';

const IrpSearchContext = createContext<IrpSearchState | undefined>(undefined);
const IrpSearchDispatchContext = createContext({} as any);

const IrpSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: IrpSearchState = {
        modality: [],
        parameters: {
            page: 0,
            pageSize: 100,
            sortBy: IrpSortField.UpdatedDate,
            sortDirection: SortDirection.Descending
        } as IIrpPageRequest,
        searchTrigger: 0,
    };

    const [state, dispatch] = useReducer(IrpSearchReducer, initialState);

    return (
        <IrpSearchContext.Provider value={state}>
            <IrpSearchDispatchContext.Provider value={dispatch}>
                {children}
            </IrpSearchDispatchContext.Provider>
        </IrpSearchContext.Provider>
    );
}

const useIrpSearchState = () => {
    const context = useContext(IrpSearchContext);
    if (context === undefined) {
        throw new Error('useIrpSearchState must be used within a IrpSearchProvider');
    }
    return context;
}

const useIrpSearchDispatch = () => {
    const context = useContext(IrpSearchDispatchContext);
    if (context === undefined) {
        throw new Error('useIrpSearchDispatch must be used within a IrpSearchProvider');
    }
    return context;
}

export { IrpSearchProvider, useIrpSearchDispatch, useIrpSearchState, ACTION_TYPES };
